// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5JDS5","question":"styles_question__1RqJt","description":"styles_description__LGd3o"};